<script>
export default {
  name: 'BlockListRowItem',
  components: {},
  props: {
    label: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="block-list-row-item">
    <template v-if="label && $slots.default">
      <div class="flex align-center justify-start">
        <div class="label">{{ label }}</div>
        <slot v-if="$slots.default" name="default"></slot>
      </div>
    </template>
    <slot v-else-if="$slots.default" name="default"></slot>
    <div v-else class="flex align-center justify-start">
      <div class="label">{{ label }}</div>
      <div>{{ content }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.block-list-row-item {
  min-width: 250px;
  color: var(--color-text-1);
}
.label {
  &::after {
    content: '：';
  }
}
</style>